import React, { Component } from 'react';
import { Table, Pager } from 'react-bootstrap';
import swal from 'sweetalert';
import 'sweetalert/dist/sweetalert.css';
import { translate } from 'react-i18next';
import Moment from 'react-moment';
import WaitingModal from '../../generics/WaitingModal';
import {checkmark} from 'react-icons-kit/icomoon/checkmark';
import {cross} from 'react-icons-kit/icomoon/cross';
import {minus} from 'react-icons-kit/icomoon/minus';
import SvgIcon from 'react-icons-kit';
import ModalSingleValidation from './ModalSingleValidation';
import ModalGrupoRH from '../../offers/components/ModalGrupoRH';
import {droplet} from 'react-icons-kit/icomoon/droplet';
import ModalSections from './modalSections';
import ModalCounter from './modalCounter';
import moment from 'moment';
import $ from 'jquery';

var Config = require('../../../config');

class TableValidation extends Component {

  constructor(props, context) {
    super(props, context);
    
    this.deleteMsg = this.deleteMsg.bind(this);
    this.validate = this.validate.bind(this);
    this.openModalSections = this.openModalSections.bind(this);
    this.cascadeValidation = this.cascadeValidation.bind(this);
    this.bossValidation = this.bossValidation.bind(this);
    this.headshipValidation = this.headshipValidation.bind(this);

    this.state = {
      columns:[],
      pagination:[],
      lab_req_boos_validation:"NO",
      boss:false,
      patient: true
    };
  }

  componentDidMount() {
    this.props.onRef(this);
    var patient = false;
    if(this.props.location.pathname === '/validation_donation/patient'){
      this.setState({patient: true});
      patient = true;
    }else{
      this.setState({patient:false})
    }

     fetch(Config.default.apiGateway.URL+'list_show?option=list_key&search='+(patient ? 'SAMPLES_VALIDATION' : 'DONATIONS'),{ 
      method: 'get',
      headers: new Headers({
         'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
         'Accept': 'application/json',
          'Content-Type': 'application/json',
      })
    })
    .then(response => response.json())
    .then(response => {
      if(response !== undefined){
        this.setState({ columns: response });
      }
    })

    fetch(Config.default.apiGateway.URL+'functional_criterion?code=LAB_REQ_BOOS_VALIDATION',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
					lab_req_boos_validation: response.value
				});
		})
  }

  componentWillUnmount() {
    this.props.onRef(null)

  }

  //Mensaje de alerta, confirmar eliminacion
  deleteMsg(id,props){
    swal({
        title: '¿Está seguro?',
        text: '¿Desea eliminar este registro?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#DD6B55',
        confirmButtonText: '¡Si, Eliminar!',
        cancelButtonText: '¡No, Cancelar!',
        closeOnConfirm: true,
        closeOnCancel: true
    }, function (isConfirm) {
        if (isConfirm) {
          /*fetch(Config.default.apiGateway.URL+'offers/'+id,{ 
            method: 'delete',
            headers: new Headers({
               'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
               'Accept': 'application/json',
              'Content-Type': 'application/json',
            })
          })
          .then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error!', result, 'error');
              });
            }})
          .then(res => {
              if(res !== undefined){
                swal('Buen Trabajo', 'Registro Eliminado','success');
                props.refresh();
              }console.log(res);
          })*/
        }
    });
  };

  concatGroupRH(group_test){
    var res = "";

      if(group_test !== undefined && group_test!==null){
        if(group_test.RH==="POSITIVO"){
          res = group_test.group+'+'
        }else{
          res = group_test.group+'-';
        }
        if(res.length>0){
          if(group_test.lectina !== null){
            var position = 1;
            res = [res.slice(0, position),group_test.lectina, res.slice(position)].join('');
          }
        }
      }

    return res;
  }

  openModalValidation(e, validate, donation_id, sections, petitions, type='single'){
    e.preventDefault();
    if(validate === "PENDING" || validate === "REMOVED"){
      
      var lab_sections = JSON.parse(sessionStorage.getItem("lab_sections_has_user_profiles"));
      var obj = [];
      var names = "";

      if(this.state.patient){
        var petition_id = petitions[0].id;
      }

      lab_sections.map((s)=>{
        if(s.validate_results){
          var indexSection = sections.findIndex((obj => obj.lab_section_id === s.lab_sections_id));
          if(indexSection !== -1){
            obj.push(s.lab_sections_id);
            
            names += sections[indexSection].lab_section_name+', '
          }
            
        }
      })
      names = names.slice(0, (names.length - 2));
   
      if(obj.length < lab_sections.length){
         swal({
              title: '¿Está seguro?',
              text: 'Las secciones permitidas para validar son '+names,
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#DD6B55',
              confirmButtonText: '¡Si, Validar!',
              cancelButtonText: '¡No, Cancelar!',
              closeOnConfirm: true,
              closeOnCancel: true
          }, function (isConfirm) {
              if (isConfirm) {                  
                  this.waiting_modal.handleShow("Validando Resultados...");
                  setTimeout(function(){
                    //this.validate(donation_id, obj);
                    if(this.state.patient){
                      this.openModalSections(donation_id, obj, sections, 'single', petition_id);  
                    }else{
                      this.openModalSections(donation_id, obj, sections, 'single');
                    }
                    
                  }.bind(this), 1000);
                  
              }
          }.bind(this));
      
      }else if(obj.length === lab_sections.length){
        
        //this.waiting_modal.handleShow("Validando Resultados...");
        setTimeout(function(){
          //this.validate(donation_id, obj);
          if(this.state.patient){
            this.openModalSections(donation_id, obj, sections, 'single', petition_id);
          }else{
            this.openModalSections(donation_id, obj, sections, 'single');
          }
          
        }.bind(this), 1000);
      }

    }else{
      swal('¡Error!', '¡No hay resultados pendientes por validar!', 'error');
    }
  }

  bossValidation(){
    var primero = '', ultimo = '';

    this.props.items.map((item, i)=>{
      if(i === 0){
        primero = item.item.donation_number;
      }
      if(this.props.items.length - 1 === i){
        ultimo = item.item.donation_number;
      }
    })

    swal({
        title: '¿Está seguro?',
        text: '¿Quieres validar las mustras de '+primero+' -> '+ultimo+' que estan en pantalla?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#DD6B55',
        confirmButtonText: '¡Si!',
        cancelButtonText: '¡No!',
        closeOnConfirm: true,
        closeOnCancel: true
    },  (isConfirm)=> {
        if (isConfirm) {
          this.setState({boss: true});

          setTimeout(()=>{
            this.openModalSections('', '', this.props.state.sections, 'jefatura')
          }, 500);
        }
    });

    if(this.props.location.pathname === '/validation_donation'){
      $('.cancel').on('click', ()=>{
          this.setState({boss: false});

          setTimeout(()=>{
            //this.openModalSections('', '', this.props.state.sections, 'cascade')
          }, 500);
      })
    }
    
  };

  validate(donation_id, sections, petition=""){
    this.waiting_modal.handleShow('Validando...');

    var url = 'donations/validate_donation?donation_id='+
              donation_id+"&health_facilities_id="+sessionStorage.getItem("health_facilities_id");

    if(petition !== ""){
      url = 'samples/validate_sample_patients?petition_id='+petition+'&sample_id='+donation_id+
            "&health_facilities_id="+sessionStorage.getItem("health_facilities_id")
    }

    fetch(Config.default.apiGateway.URL+url,{
      method :'POST',
      body:JSON.stringify(sections),
      headers: new Headers({
        'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
        'Accept'    : 'application/json',
        'Content-Type'  : 'application/json'
      }) 
    })
    .then(res => {
        this.waiting_modal.handleClose();
        if(res.ok){
          return res.json();
        }else{
          res.text().then(function(error) {
            swal('¡Error!', error, 'error');
          });
        }
    })
    .then(response => {
      if(response !== undefined){
        var msg = "<table class='table' style='text-align:left;'>"+
                  "<thead>"+
                    "<tr>"+
                      "<th style='text-align:center'>Sección</th>"+
                      "<th style='text-align:center'>Estatus</th>"+
                      "<th style='text-align:center'>Mensaje</th>"+
                    "</tr>"+
                  "</thead>"+
                  "<tbody>";
        for(var i =0;i < response.length;i++){
          msg += "<tr>"+
                    "<td>"+response[i].lab_section+"</td>"+
                    "<td>"+response[i].status.toUpperCase()+"</td>"+
                    "<td>"+response[i].message+"</td>"+
                  "</tr>";
        }
              
        msg += "</tbody></table>";
        
        swal({
          title: "Proceso Terminado",
          html:true,
          text: msg,
          type: 'success',
        }, function (isConfirm) {
            if (isConfirm) {
              this.props.refresh();
            }else{
              return false;
            }
        }.bind(this));
      }
    })
  }

  cascadeValidation(ids){
    //event.preventDefault();
    var don_ids = [];
    for(var i=0; i < this.props.items.length;i++){
      if(this.props.items[i].item.validation == "PENDING" || this.props.items[i].item.validation == "REMOVED"){
        if(this.state.patient){
          don_ids.push(this.props.items[i].item.id);
        }else{
          don_ids.push(this.props.items[i].item.donation_id);
        }
        
      }
    }
    if(ids.length > 0 && don_ids.length > 0){
        var aux_date = new Date();
        if(this.props.state.start_date===""){
          this.props.state.start_date=aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2);
        }

        var obj = {};
        var url = '';

        if(this.state.patient){
          url = 'samples/cascade_samples_validation';
          obj = {
            health_facilities_id: sessionStorage.getItem('health_facilities_id'),
            lab_sections_ids: ids,
            samples_id: don_ids
          }
        }else{
          url = 'donations/cascade_validation';
          obj = {
            lab_sections_id:ids,
            donation_ids:don_ids,
            health_facilities_id:sessionStorage.getItem("health_facilities_id"),
            boos_validation: this.state.boss
          }
        }
      

        this.modal_counter.handleShow('Validando...', don_ids.length);
        fetch(Config.default.apiGateway.URL+url,{ 
          method: 'post',
          body:JSON.stringify(obj),
          headers: new Headers({
             'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
             'Accept': 'application/json',
            'Content-Type': 'application/json',
          })
        })
        .then(res => {
          this.modal_counter.handleClose();
          if(res.ok){
            return res.json();
          }else{
            res.text().then(function(result) {
              swal('¡Error!', result, 'error');
            });
          }})
        .then(res => {
            if(res !== undefined){
              var msg = "<div style='max-height: 500px;overflow-y: scroll'><table class='table' style='text-align:left'>"+
                          "<thead>"+
                            "<tr>"+
                              "<th>"+(this.state.patient ? "No. Muestra" :"No. Donación")+"</th>"+
                              "<th>Sección</th>"+
                              "<th>Estatus</th>"+
                              "<th>Mensaje</th>"+
                            "</tr>"+
                          "</thead>"+
                          "<tbody>";
              for(var i =0;i < res.length;i++){
                msg += "<tr>"+
                          "<td>"+res[i].donation_number+"</td>"+
                          "<td>"+res[i].lab_section+"</td>"+
                          "<td>"+res[i].status+"</td>"+
                          "<td>"+res[i].message+"</td>"+
                        "</tr>";
              }
              msg += "</tbody></table><div>";
              swal({
                  title: "Proceso Realizado",
                  html:true,
                  text: msg,
                  customClass: 'swal-wide',
              });
              this.props.refresh();
            }
        })
    }else{
      swal('¡Error!', "No existe ninguna donación", 'error');
    }
  }

  showColumn(column_name){
    var i =0;
    if(this.props.columns.length > 0){
      for(i =0; i < this.props.columns.length;i++){
          if(this.props.columns[i]=== column_name){
          return false;
        }
      }

    }else{
      for(i =0; i < this.state.columns.length;i++){
        if(this.state.columns[i]=== column_name){
          return false;
        }
      }
      
    }

    return true;
  }

  paginator(item, page, per_page){
    var page        = page || 1,
    per_page        = per_page || 100,
    offset          = (page - 1) * per_page,
    paginatedItems  = item.slice(offset).slice(0, per_page),
    total_pages     = Math.ceil(item.length / per_page);
    var pagination  = {
      page        : page,
      per_page    : per_page,
      pre_page    : page - 1 ? page - 1 : null,
      next_page   : (total_pages > page) ? page + 1 : null,
      total       : item.length,
      total_pages : total_pages,
      data        : paginatedItems
    }

    this.setState({
      pagination:pagination
    })
         
  }

  singleValidation(e, section, item){
    e.preventDefault();
    this.single_validation.handleShow(item.donation_id, section.lab_sections_id, section.name, item.samples_id);
  }

  getIconSectionColor(sections_color, lab_section_id){
    for(var i=0;i < sections_color.length;i++){
      if(sections_color[i].lab_section_id === lab_section_id){
        return sections_color[i].color;
      }
    }

    return "";
  }

  openModalGrupoRH(e, item){
    e.preventDefault();

    var group_test_id = 0;
    if(item.group_test !== null){
      group_test_id = item.group_test.id;
    }
    this.modal_grupo_rh.handleShow(item.donor_id, item.offers_id, group_test_id, item.group_test, "");
    
  }

  openModalSections(donation_id, ids_section, sections, type, petition_id){
    this.props.waiting.handleShow('Cargando...');

    if(this.state.patient){
      this.modal_sections.handleShow(donation_id, sections, type, petition_id)
    }else{
      this.modal_sections.handleShow(donation_id, sections, type)
    }
    
  }

  headshipValidation(ids){
    //event.preventDefault();
    var don_ids = [];
    for(var i=0; i < this.props.items.length;i++){
      don_ids.push(this.props.items[i].item.donation_id);
    }
    if(ids.length > 0 && don_ids.length > 0){
        var aux_date = new Date();
        if(this.props.state.start_date===""){
          this.props.state.start_date=aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2);
        }

        var obj = {
          section_ids: ids,
          donation_id: don_ids,
        }

        this.modal_counter.handleShow('Validando...', don_ids.length);
        fetch(Config.default.apiGateway.URL+'headship_validation',{ 
          method: 'post',
          body:JSON.stringify(obj),
          headers: new Headers({
             'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
             'Accept': 'application/json',
            'Content-Type': 'application/json',
          })
        })
        .then(res => {
          this.modal_counter.handleClose();
          if(res.ok){
            return res.json();
          }else{
            res.text().then(function(result) {
              swal('¡Error!', result, 'error');
            });
          }})
        .then(res => {
            if(res !== undefined){
             
              swal(
                  "Proceso Realizado",
                  '',
                  'success'
              );
              this.props.refresh();
            }
        })
    }else{
      swal('¡Error!', "No existe ninguna donación", 'error');
    }
  }
  //Contenido de la tabla
  render () {
    const { t } = this.props;

    return (
      <div>
        <Table responsive hover>
          <thead>
            {this.state.patient ? 
              <tr>
                <th hidden={this.showColumn('CONVOKE_PLACES')}>Lugar de Colecta</th>
                <th hidden={this.showColumn('PETITION_NUMBER')}>No. Petición</th>
                <th hidden={this.showColumn('SAMPLE_NUMBER')}>No. Muestra</th>
                <th hidden={this.showColumn('PATIENT')}>Paciente</th>
                <th hidden={this.showColumn('SAMPLE_TIMESTAMP')}>Fecha</th>
                <th></th>
              </tr>
            :
              <tr>
                <th hidden={this.showColumn('CONVOKE_PLACE')}>Lugar de Colecta</th>
                <th hidden={this.showColumn('DONOR_ID')}>{t('content.results_donation.donor_number')}</th>
                <th hidden={this.showColumn('DONATION_NUMBER')}>{t('content.results_donation.donation_number')}</th>
                <th hidden={this.showColumn('OFFER_ID')}>{t('content.results_donation.offer_id')}</th>
                <th hidden={this.showColumn('DONATION_TYPE')}>{t('content.results_donation.donation_type')}</th>
                <th hidden={this.showColumn('EXTRACTION_TYPE')}>{t('content.results_donation.extraction_type')}</th>
                <th hidden={this.showColumn('DONOR_NAME')}>{t('content.results_donation.donor_name')}</th>
                <th hidden={this.showColumn('GROUP_RH_INITIAL')}>Grupo Inicial</th>
                <th hidden={this.showColumn('GROUP_RH')}>Grupo & RH</th>
                <th hidden={this.showColumn('REGISTER_DATE')}>{t('content.results_donation.timestamp')}</th>
                <th hidden={this.showColumn('VALIDATED')} style={{textAlign:"center"}}>{t('content.results_donation.validate')}</th>
              </tr>
            }
           
          </thead>
          <tbody>
          {this.state.pagination.data !== undefined ?            
            this.state.pagination.data.map((obj, index)=>                
                  this.state.patient ?
                    <tr key={index}>
                      <td hidden={this.showColumn('CONVOKE_PLACES')}>{obj.item.convoke_place_name}</td>
                      <td hidden={this.showColumn('PETITION_NUMBER')}>{obj.item.petition_number}</td>
                      <td hidden={this.showColumn('SAMPLE_NUMBER')}>{obj.item.number}</td>
                      <td hidden={this.showColumn('PATIENT')}>{obj.item.patient}</td>
                      <td hidden={this.showColumn('SAMPLE_TIMESTAMP')}>{moment(obj.item.tiemestamp).format('DD/MM/YYYY')}</td>
                      <td style={{textAlign:"center"}}>
                        {obj.item.validation==="ACCEPTED"?
                            <button style={{fontSize:".5em", textAlign:"center"}} align="center" className="btn btn-success" type="button">
                            <SvgIcon icon={checkmark}/></button>
                          :obj.item.validation==="REJECT" || obj.item.validation === "DISCREPANT"?
                            <button style={{fontSize:".5em"}} className="btn btn-danger" type="button"><SvgIcon icon={cross}/></button>
                          : <button style={{fontSize:".5em",backgroundColor:"orange",color:"white"}} className="btn" type="button" 
                              onClick={(e) => this.openModalValidation(e,obj.item.validation, obj.item.id, obj.sections_color, obj.item.petitions)}>
                              <SvgIcon icon={minus}/>
                            </button>
                        }
                      </td>
                    </tr>
                  :
                    <tr key={index}  style={{backgroundColor:obj.register_color}}>
                      <td hidden={this.showColumn('CONVOKE_PLACE')}>{obj.item.convoke_place_name}</td>
                      <td hidden={this.showColumn('DONOR_ID')}>{obj.item.donor_number}</td>
                      <td hidden={this.showColumn('DONATION_NUMBER')}>{obj.item.donation_number}</td>
                      <td hidden={this.showColumn('OFFER_ID')}>{obj.item.offers_id}</td>
                      <td hidden={this.showColumn('DONATION_TYPE')}>{obj.item.donation_type}</td>
                      <td hidden={this.showColumn('EXTRACTION_TYPE')}>{obj.item.extraction_type}</td>
                      <td hidden={this.showColumn('DONOR_NAME')}>{obj.item.donor_name}</td>
                      <td hidden={this.showColumn('GROUP_RH_INITIAL')}>
                        {
                        <a href="#" 
                          onClick={(e) => this.openModalGrupoRH(e,obj.item)} 
                          >
                          {obj.item.group_test != null?
                            this.concatGroupRH(obj.item.group_test)
                          :<SvgIcon size={25} icon={droplet} title="Grupo & RH"/>
                          }
                        </a>}
                      </td>
                      <td hidden={this.showColumn('GROUP_RH')}>{obj.item.group_rh}</td>
                      <td hidden={this.showColumn('REGISTER_DATE')}>
                        <Moment format="DD/MM/YYYY">{obj.item.timestamp_date}</Moment>{' '}
                        <Moment parse="HH:mm" format="h:mm a">{obj.item.timestamp_hour}</Moment>
                      </td>
                      
                      <td hidden={this.showColumn('VALIDATED')} style={{textAlign:"center"}}>
                        {obj.item.validation==="ACCEPTED"?
                            <button style={{fontSize:".5em", textAlign:"center"}} align="center" className="btn btn-success" type="button">
                            <SvgIcon icon={checkmark}/></button>
                          :obj.item.validation==="REJECT" || obj.item.validation === "DISCREPANT"?
                            <button style={{fontSize:".5em"}} className="btn btn-danger" type="button"><SvgIcon icon={cross}/></button>
                          : <button style={{fontSize:".5em",backgroundColor:"orange",color:"white"}} className="btn" type="button" 
                              onClick={(e) => this.openModalValidation(e,obj.item.validation, obj.item.donation_id, obj.sections_color)}>
                              <SvgIcon icon={minus}/>
                            </button>
                        }
                      </td>
                    </tr>
            )
          : null        
          }

          </tbody>
        </Table>

        <Pager>                          
          <Pager.Item disabled={this.state.pagination.pre_page === null}
            onClick={function(){this.paginator(this.props.items, this.state.pagination.pre_page)}.bind(this)} 
            href="#">Anterior</Pager.Item>
          {' Página '+this.state.pagination.page+' de '+this.state.pagination.total_pages+' '}
          <Pager.Item disabled={this.state.pagination.next_page === null} 
            onClick={function(){this.paginator(this.props.items, this.state.pagination.next_page)}.bind(this)} 
            href="#">Siguiente</Pager.Item>                            
        </Pager>

        <div className="col-xs-12 form-group">

          <button style={{float:"right", fontSize:"1em"}} className="btn btn-danger" type="button" 
            disabled={this.state.pagination.data !== undefined ? this.state.pagination.data.length === 0 : true}
            onClick={(e) => /*this.cascadeValidation(e)*/ this.openModalSections('', '', this.props.state.sections, 'cascade')}>
            {t('content.validation_donation.cascade_validation')}
          </button>
        </div>

        {(this.state.lab_req_boos_validation !== 'NO' && !this.state.patient) &&
          <div className="col-xs-12 form-group">
            <button style={{float:"right", fontSize:"1em"}} className="btn btn-info" type="button" 
              disabled={this.state.pagination.data !== undefined ? this.state.pagination.data.length === 0 : true}
              onClick={(e) => this.bossValidation(e)}>
              Validación Jefatura
            </button>
          </div>
        }
        

        <WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
        <ModalCounter {...this.props} onRef={ref => (this.modal_counter = ref)}/>
        <ModalSections {...this.props} onRef={ref => (this.modal_sections = ref)} validate={this.validate} 
          cascade={this.cascadeValidation} headship={this.headshipValidation} />
        <ModalSingleValidation {...this.props} onRef={ref => (this.single_validation = ref)} refresh={this.props.refresh} state={this.props.state} />
        <ModalGrupoRH {...this.props} onRef={ref => (this.modal_grupo_rh = ref)} refresh={this.props.refresh}/>
      </div>
    );
  }
}

export default translate('translations')(TableValidation)